import { createSlice } from '@reduxjs/toolkit'

const subscriptionStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    currentSubStatus: subscriptionStatus.LOADING,
    currentSubErrorMessage: null,
    currentSub: {
        subscription: {},
    },
    subHistoryStatus: subscriptionStatus.LOADING,
    subHistoryErrorMessage: null,
    subHistory: [],
}

const subscriptionSlice = createSlice({
    name: 'account/subscription',
    initialState,
    reducers: {
        getCurrentSubRequest: state => {
            state.currentSubStatus = subscriptionStatus.LOADING
        },
        getCurrentSubRequestSuccess: (state, action) => {
            state.currentSubStatus = subscriptionStatus.SUCCESS
            state.currentSub = action.payload
        },
        getCurrentSubRequestError: (state, action) => {
            state.currentSubStatus = subscriptionStatus.FAILURE
            state.currentSubErrorMessage = action.payload
        },
        getSubHistoryRequest: state => {
            state.subHistoryStatus = subscriptionStatus.LOADING
        },
        getSubHistoryRequestSuccess: (state, action) => {
            state.subHistoryStatus = subscriptionStatus.SUCCESS
            state.subHistory = action.payload
        },
        getSubHistoryRequestError: (state, action) => {
            state.subHistoryStatus = subscriptionStatus.FAILURE
            state.subHistoryErrorMessage = action.payload
        },
    },
})

const {
    getCurrentSubRequest,
    getCurrentSubRequestSuccess,
    getCurrentSubRequestError,
    getSubHistoryRequest,
    getSubHistoryRequestSuccess,
    getSubHistoryRequestError,
} = subscriptionSlice.actions

export const subscriptionActions = {
    getCurrentSubRequest,
    getCurrentSubRequestSuccess,
    getCurrentSubRequestError,
    getSubHistoryRequest,
    getSubHistoryRequestSuccess,
    getSubHistoryRequestError,
}

export const subscriptionSelectors = {
    isFetchingCurrentSub: state =>
        state.accountSubscription.currentSubStatus ===
        subscriptionStatus.LOADING,
    currentSubHasError: state =>
        state.accountSubscription.currentSubStatus ===
        subscriptionStatus.FAILURE,
    currentSubErrorMessage: state =>
        state.accountSubscription.currentSubErrorMessage,
    currentSub: state => state.accountSubscription.currentSub,
    isFetchingSubHistory: state =>
        state.accountSubscription.subHistoryStatus ===
        subscriptionStatus.LOADING,
    subHistoryHasError: state =>
        state.accountSubscription.subHistoryStatus ===
        subscriptionStatus.FAILURE,
    subHistoryErrorMessage: state =>
        state.accountSubscription.subHistoryErrorMessage,
    subHistory: state => state.accountSubscription.subHistory,
}

export default subscriptionSlice.reducer
